<template>
  <div class="smy__card-full-box">
      <div class="orderDetalRight">
        <div class="step" style=" padding:0px 0px 10px 0;border-bottom:1px solid #e9eaec;margin:0 0px">
          <Steps class="step" :current="dataOne">
            <Step title="创建"></Step>
            <Step title="代理经理审批"></Step>
            <Step title="是否付款"></Step>
            <Step title="已开通"></Step>
          </Steps>
        </div>
      </div>
      <div class="timeLine" style="padding:20px 20px;line-height:20px;">
        <Timeline>
         <TimelineItem
          v-for="TimeList in orderDetail.examineLogs"
          :key="TimeList.id"
          :value="TimeList.id"
         >
         <span style="float:right;">{{TimeList.create_time}}</span>
             <p class="time"
              v-if = "TimeList.node === 1"
             >{{TimeList.examine_user_name+'【代理商】'}}</p>
             <p class="time"
              v-if = "TimeList.node === 2"
             >{{TimeList.examine_user_name+'【渠道经理】'}}</p>
             <p class="time"
              v-if = "TimeList.node === 3"
             >{{TimeList.examine_user_name+'【平台总管理】'}}</p>
             <p class="content"
              v-if="TimeList.type === 1"
             >审批通过</p>
             <template   v-if="TimeList.type === 2">
             <p class="content">审批失败</p>
             <p>{{TimeList.reason}}</p>
           </template>
         </TimelineItem>
         <TimelineItem>
         <span style="float:right;">{{orderDetail.create_time}}</span>
         <p class="time"
         >{{orderDetail.order_user_name+'【代理商业务员】'}}</p>
         <p>创建订单</p>
       </TimelineItem>
       </Timeline>
      </div>
  </div>
</template>

<script>

export default {
  props: {
    orderDetail: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      dataOne: 0
    }
  },
  computed: {
    dataWrong () {
      if (this.orderDetail.order_state === 0 || this.orderDetail.order_state === 1) {
        this.dataOne = 1
      } else if (this.orderDetail.order_state === 2) {
        this.dataOne = 2
      } else if (this.orderDetail.order_state === 3 || this.orderDetail.order_state === 4 || this.orderDetail.plantform_examine_state === 0 || this.orderDetail.plantform_examine_state === 1) {
        this.dataOne = 3
      } else if (this.orderDetail.order_state === 5) {
        this.dataOne = 4
      }
    }
  },
  methods: {
  },
  created () {
  }
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/handle/agOrderPay/OrderDetailRight.vue